<template>
	<div :class="cssClasses">
		<slot></slot>
	</div>
</template>

<script>
const sides = ['left', 'right', 'center'];

export default {
	props: ['side'],
	data() {
		return {
			cssClasses: [
				'fixed',
				sides.find(s => s === this.side) || 'left',
			]
		};
	},
}
</script>

<style scoped>
.fixed {
	position: fixed;
	bottom: 0;
	margin: 20px;
}

.left {
	left: 0;
}

.right {
	right: 0;
}

.center {
	left: 50%;
	transform: translateX(-50%)
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Fixed.vue